export const FIELD =
  "mt-1 w-full rounded-lg border border-[#E3DED4] bg-white px-3 py-2 text-sm text-[#45423C] shadow-sm transition-colors " +
  "focus:border-[#B9AE9A] focus:outline-none focus:ring-2 focus:ring-[#B9AE9A]/20 " +
  "disabled:cursor-not-allowed disabled:bg-[#F7F5F1] disabled:text-[#6F6A60]";

export const FIELD_NUM = `${FIELD} text-right tabular`;

export const LABEL = "block text-xs font-semibold uppercase tracking-wider text-[#6F6A60]";

export const CARD = "rounded-2xl border border-[#E3DED4] bg-white shadow-sm";

export const BTN_PRIMARY =
  "inline-flex items-center justify-center gap-2 rounded-xl bg-[#45423C] px-4 py-2.5 text-sm font-semibold text-white " +
  "shadow-sm transition-all hover:bg-[#56524A] hover:shadow-md active:scale-[0.98] disabled:opacity-40 disabled:hover:shadow-sm";

export const BTN_GHOST =
  "inline-flex items-center justify-center gap-2 rounded-xl border border-[#E3DED4] bg-white px-4 py-2.5 text-sm font-semibold " +
  "text-[#45423C] transition-all hover:border-[#B9AE9A] hover:shadow-sm active:scale-[0.98] disabled:opacity-40";
